<template>
  <div class="container">
    <div v-if="onlinePay">
      <div class="mwow-top-title">
        <span class="text">退款记录</span>
      </div>
      <el-form size="mini" :model="searchInfo" inline>
        <el-form-item label="退款时间：" prop="time">
          <!-- <el-date-picker
            v-model="searchInfo.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleSearch"
            value-format="timestamp"
          >
          </el-date-picker> -->
          <common-date-range-selector
            v-model="searchInfo.time"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleSearch"
            value-format="timestamp"
          >
          </common-date-range-selector>
        </el-form-item>
        <el-form-item label="退款单号：">
          <el-input
            v-model="searchInfo.refund_no"
            placeholder="请输入退款单号"
            @change="handleSearch"
            clearable
            maxlength="999"
          ></el-input>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input
            v-model="searchInfo.biz_id"
            placeholder="请输入订单号"
            @change="handleSearch"
            clearable
            maxlength="999"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 12px">
        <div
          class="mwow-button-filled success"
          @click="handleExport"
          v-debounce="1000"
        >
          导出
        </div>
      </div>
      <el-table
        class="mwow-table"
        v-horizontal-scroll
        size="mini"
        :data="tableData"
        stripe
        style="width: 100%"
        tooltip-effect="dark"
      >
        <el-table-column label="序号" type="index" width="60"></el-table-column>
        <el-table-column
          label="退款时间"
          prop="trade_time"
          width="150px"
        ></el-table-column>
        <el-table-column label="退款单号" prop="refund_no"></el-table-column>
        <el-table-column label="订单号" prop="biz_id">
          <template slot-scope="scope">
            <div
              style="color: #07d1aa; cursor: pointer"
              @click="toOrderDetail(scope.row, 'biz_id')"
            >
              {{ scope.row.biz_id ? scope.row.biz_id : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="原订单号" prop="org_biz_id">
          <template slot-scope="scope">
            <div
              style="color: #07d1aa; cursor: pointer"
              @click="toOrderDetail(scope.row, 'org_biz_id')"
            >
              {{ scope.row.org_biz_id ? scope.row.org_biz_id : "-" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="退款金额"
          prop="refund_amount"
          min-width="100px"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.refund_amount">
              {{ scope.row.refund_amount }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
        <el-table-column label="退回手续费金额" prop="refund_fee_amount">
          <template slot-scope="scope">
            {{
              scope.row.refund_fee_amount ? scope.row.refund_fee_amount : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="退回服务费金额" prop="refund_wow_fee_amount">
          <template slot-scope="scope">
            {{
              Number(scope.row.refund_wow_fee_amount)
                ? scope.row.refund_wow_fee_amount
                : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="支付订单编号" prop="order_no">
          <template slot-scope="scope">
            {{ scope.row.order_no ? scope.row.order_no : "-" }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="pageSizeArray"
        :style="{ float: 'right', padding: '20px' }"
        :total="total"
        @current-change="handlePagerChange"
        @size-change="handlePagerSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <div v-else>
      <div class="online-pay-tips">
        <div class="bg-block">
          <div class="info">
            <img
              src="https://wowsite.musicwow.com/teaching_system_frontend/images/finance/notOpen.png"
              alt=""
            />
            <div class="text">还未申请开通门店支付</div>
          </div>
          <div class="buttons">
            <div class="btn" @click="toStoreWallet">立即开通</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { exportLoop } from "@/utils/export";
import { dateFormat } from "@/utils/timeFormat";
import { getPaymentRefundLogApi, exportPaymentRefundLogApi } from "@/api/order";
import { UserModule } from "@/store/module/user";
import { PageModule } from "@/store/module/page";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonDateRangeSelector,
  },
  data() {
    return {
      searchInfo: {
        time: [],
        refund_no: "",
        biz_id: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      onlinePay: false,
    };
  },
  created() {
    this.onlinePay = UserModule.userInfo.online_pay;
    // 从 vuex 中获取页面缓存数据
    const searchListInfo = PageModule.pageInfo.financialRefundRecord;
    if (searchListInfo.page) {
      this.page = searchListInfo.page;
    }
    if (searchListInfo.page_size) {
      this.pageSize = searchListInfo.page_size;
    }
    if (this.onlinePay) {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    solveParams() {
      let option = {};
      if (this.searchInfo.time && this.searchInfo.time.length === 2) {
        option.trade_time_1 = this.searchInfo.time[0] / 1000;
        option.trade_time_2 = this.searchInfo.time[1] / 1000 + 24 * 60 * 60 - 1;
      }
      if (this.searchInfo.refund_no) {
        option.refund_no = this.searchInfo.refund_no;
      }
      if (this.searchInfo.biz_id) {
        option.biz_id = this.searchInfo.biz_id;
      }
      return option;
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
        ...this.solveParams(),
      };
      getPaymentRefundLogApi(option).then((res) => {
        res.data.list.map((item) => {
          item.trade_time = dateFormat(
            "YYYY-mm-dd HH:MM",
            new Date(item.trade_time * 1000)
          );
        });
        this.page = res.data.page;
        this.total = res.data.total;
        this.tableData = res.data.list;
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleExport() {
      if (!this.searchInfo.time || this.searchInfo.time.length !== 2) {
        this.$message({
          type: "warning",
          message: "导出必须选定时间范围",
        });
        return false;
      }
      const option = this.solveParams();
      exportPaymentRefundLogApi(option).then((res) => {
        exportLoop(res.data.task_id);
      });
    },
    toStoreWallet() {
      this.$router.push({
        name: "storeWallet",
      });
    },
    // 缓存需要的数据
    cachePageInfo() {
      PageModule.SET_PAGE_INFO({
        name: "financialRefundRecord",
        key: "search_info",
        value: this.searchInfo,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialRefundRecord",
        key: "page",
        value: this.page,
      });
      PageModule.SET_PAGE_INFO({
        name: "financialRefundRecord",
        key: "page_size",
        value: this.pageSize,
      });
    },
    toOrderDetail(row, type) {
      // 跳转前，将 searchInfo、page 数据缓存，等返回时使用
      sessionStorage.setItem(
        "refundRecord",
        JSON.stringify("financial_refundRecord")
      );
      this.cachePageInfo();
      // 订单
      if (type === "biz_id") {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            ono: row.biz_id,
          },
        });
      }
      // 原订单
      if (type === "org_biz_id" && row.org_biz_id) {
        this.$router.push({
          name: "orderManageDetail",
          query: {
            ono: row.org_biz_id,
          },
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
.online-pay-tips {
  height: 60vh;
  .bg-block {
    text-align: center;
    margin-top: 28vh;
    .info {
      margin-bottom: 5px;
      img {
        width: 52px;
        height: 50px;
      }
      .text {
        font-size: 14px;
        margin: 11px 0;
      }
    }
    .buttons {
      .btn {
        margin: 0 auto;
        background: #07d1aa;
        color: white;
        width: 84px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 5px;
      }
      .btn:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
